const ITEM = '[data-uc-reveal]';
const GROUP = '[data-uc-reveal-group]';
const ROOT_MARGIN = '0px 0px -12% 0px';
const STAGGER_LIMIT = 12;

const expand = (el) => (el.matches(GROUP) ? Array.from(el.querySelectorAll(ITEM)) : [el]);

const init = (scope) => {
	const groups = Array.from(scope.querySelectorAll(GROUP));
	const loose = Array.from(scope.querySelectorAll(ITEM)).filter((el) => !el.closest(GROUP));

	const targets = groups.concat(loose).filter((el) => {
		if (el.dataset.ucRevealInit) return false;
		el.dataset.ucRevealInit = '1';
		return true;
	});
	if (!targets.length) return;

	const show = (items) => {
		items.forEach((el, i) => {
			el.style.setProperty('--reveal-index', Math.min(i, STAGGER_LIMIT));
			el.classList.add('is-revealed');
		});
	};

	if (!('IntersectionObserver' in window)) {
		show(targets.flatMap(expand));
		return;
	}

	const order = new Map(targets.map((el, i) => [el, i]));

	const observer = new IntersectionObserver(
		(entries) => {
			const hit = entries
				.filter((entry) => entry.isIntersecting || entry.boundingClientRect.top < 0)
				.map((entry) => entry.target)
				.sort((a, b) => order.get(a) - order.get(b));

			show(hit.flatMap(expand));

			for (const target of hit) observer.unobserve(target);
		},
		{ rootMargin: ROOT_MARGIN }
	);

	for (const target of targets) observer.observe(target);
};

init(document);

document.addEventListener('shopify:section:load', (event) => init(event.target));
